module.exports = __webpack_public_path__ + "img/hy_zn.79c8d693.svg";